import { AllowedDocumentExtensionsEffect } from "./allowed-document-extensions.effect";
import { AllowedImageExtensionsEffect } from "./allowed-image-extensions.effect";

export const effects: any[] = [
  AllowedImageExtensionsEffect,
  AllowedDocumentExtensionsEffect
];
